import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { SapId } from 'ui';

const StyledList = styled.ul`
  margin-bottom: 10px;
  padding-left: 20px;
`;

const StyledListItem = styled.li`
  margin-top: 5px;
  list-style-type: circle;
`;
const ErrorDetails = ({ errors, autoFaulty, autoTotal, translate }) => {
  const formatErrorDetails = (error) => {
    if (error.value) {
      if (error.value.errors?.length) {
        return (
          <StyledList>
            {error.value.errors?.map((e, i) =>
              <StyledListItem key={`${error.key}_${i}`}>
                {e}
              </StyledListItem>,
            )}
          </StyledList>
        );
      }
      if (error.value.message) {
        return (
          <StyledList>
            <StyledListItem>
              {error.value.message}
            </StyledListItem>
          </StyledList>
        );
      }
    }

    return translate({ id: 'toolbar.UNKNOWN_ERROR' });
  };

  return (
    <div>
      {translate(
        {
          id: `toolbar.AUTO_CREATE_FAILED${errors?.length ? '' : '_NO_ERRORS'}`,
        },
        { faulty: autoFaulty, total: autoTotal },
      )}
      {Object.entries(errors)?.map(([key, value]) =>
        <div key={key}>
          <SapId originalId={key.split('|@|').pop()}>
            {id => <span>{id}:</span>}
          </SapId>
          {formatErrorDetails(value)}
        </div>,
      )}
    </div>
  );
};

ErrorDetails.propTypes = {
  errors: PropTypes.object,
  autoFaulty: PropTypes.number,
  autoTotal: PropTypes.number,
  translate: PropTypes.func,
};

export default ErrorDetails;
